// One hook that yields an authenticated API client in both auth modes:
// Clerk (production) and the dev bypass (VITE_DEV_AUTH=true).

import { useMemo } from "react";
import { useAuth } from "@clerk/clerk-react";
import { makeApi, type Api } from "@/lib/api";
import { DEV_AUTH_ENABLED, getDevAuth } from "@/lib/devAuth";

function useClerkApi(): Api {
  const { getToken } = useAuth();
  return useMemo(
    () =>
      makeApi(async () => {
        const token = await getToken();
        return token ? `Bearer ${token}` : null;
      }),
    [getToken],
  );
}

function useDevApi(): Api {
  return useMemo(
    () =>
      makeApi(async () => {
        const auth = getDevAuth();
        return auth ? `Dev ${auth.clerkUserId}` : null;
      }),
    [],
  );
}

// Hooks must be called unconditionally, but DEV_AUTH_ENABLED is a build-time
// constant, so the branch is stable for the app's lifetime.
export const useApi: () => Api = DEV_AUTH_ENABLED ? useDevApi : useClerkApi;
